<template>
  <div class="main">
    <div class="main_tabs">
      <el-tabs v-model="activeName">
        <el-tab-pane label="安全考核" name="first"></el-tab-pane>
        <el-tab-pane label="安全考题" name="second"></el-tab-pane>
      </el-tabs>
    </div>
    <div class="main_content">
      <component :is="activeName === 'first' ? 'SafetyExamine' : 'SafetyTopic'"></component>
    </div>
  </div>
</template>

<script>
import SafetyExamine from './components/SafetyExamine.vue'; // 安全考核
import SafetyTopic from './components/SafetyTopic.vue'; // 安全考题
  export default {
    components: {
      SafetyExamine,
      SafetyTopic
    },
    data() {
      return {
        activeName: 'first'
      }
    }
  }
</script>

<style lang="scss" scoped>
@import '@/style/layout-main.scss';

/deep/.main {
  background: none;
}
</style>